import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { getHyperpureImpressionParams } from "./models/hyperpure_impression";

export const ImpressionTracker = ({
    children,
    metaData,
    eventHandler,
    className,
}) => {
    const elementRef = useRef(null);
    const observerRef = useRef(null);
    const [hasTracked, setHasTracked] = useState(false);
    const userData = useSelector((state) => state.user?.data);

    const eventHandlerRef = useRef(eventHandler);
    eventHandlerRef.current = eventHandler;
    const metaDataRef = useRef(metaData);
    metaDataRef.current = metaData;

    const hasMetaData = !!metaData;

    useEffect(() => {
        if (!window.IntersectionObserver || hasTracked) return undefined;
        if (!hasMetaData) return undefined;

        observerRef.current = new window.IntersectionObserver(
            (entries, obs) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    if (!metaDataRef.current || !eventHandlerRef.current) return;

                    eventHandlerRef.current(
                        getHyperpureImpressionParams(
                            metaDataRef.current,
                            userData?.outlet?.id,
                            userData?.outlet?.warehouseCode,
                        ),
                    );
                    setHasTracked(true);
                    obs.unobserve(entry.target);
                });
            },
            { threshold: 0.5 },
        );

        if (elementRef.current) observerRef.current.observe(elementRef.current);

        return () => {
            if (observerRef.current) observerRef.current.disconnect();
        };
    }, [
        hasTracked,
        hasMetaData,
        userData?.outlet?.id,
        userData?.outlet?.warehouseCode,
    ]);

    return (
        <div ref={elementRef} className={className}>
            {children}
        </div>
    );
};

export default ImpressionTracker;
